import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    Title,
    DoughnutController,
    ChartData,
    ChartOptions,
    Plugin,
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { forwardRef } from 'react';

ChartJS.register(ArcElement, Tooltip, Legend, Title, DoughnutController);

export interface DoughnutChartProps {
    data: ChartData<'doughnut'>;
    options?: ChartOptions<'doughnut'>;
    plugins?: Plugin<'doughnut'>[];
    testId?: string;
    heightPx?: number;
}

const DoughnutChart = forwardRef<
    ChartJS<'doughnut'> | undefined,
    DoughnutChartProps
>(function DoughnutChart(
    { data, options, plugins, testId, heightPx = 400 },
    ref
) {
    const chartOptions: ChartOptions<'doughnut'> = {
        ...options,
        responsive: true,
        maintainAspectRatio: false,
    };

    const chart = (
        <Doughnut
            ref={ref}
            data={data}
            options={chartOptions}
            plugins={plugins}
            data-testid={testId ?? 'doughnut-chart'}
        />
    );

    return (
        <div
            className="w-full flex justify-center"
            style={{ height: `${heightPx}px` }}
        >
            <div
                style={{
                    width: '100%',
                    maxWidth: '700px',
                    height: '100%',
                }}
            >
                {chart}
            </div>
        </div>
    );
});

export default DoughnutChart;
